module.exports = __webpack_public_path__ + "static/img/soft_3.55ad527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soft_3.png
// module id = gJaX
// module chunks = 0